"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _set = require("babel-runtime/core-js/set");

var _set2 = _interopRequireDefault(_set);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _frontend = require("../config/i18next/frontend");

var _frontend2 = _interopRequireDefault(_frontend);

var _i18nextLocalstorageCache = require("i18next-localstorage-cache");

var _i18nextLocalstorageCache2 = _interopRequireDefault(_i18nextLocalstorageCache);

var _i18nextBrowserLanguagedetector = require("i18next-browser-languagedetector");

var _i18nextBrowserLanguagedetector2 = _interopRequireDefault(_i18nextBrowserLanguagedetector);

var _LocaleManager2 = require("./LocaleManager");

var _LocaleManager3 = _interopRequireDefault(_LocaleManager2);

var _momentTimezone = require("moment-timezone");

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// FIXME: Figure out a way to include this in the test suite.
/* istanbul ignore next */
if (global.__TESTING__) {
  // Polyfill webpack require.ensure.
  // See http://stackoverflow.com/a/33225242/564163
  if (typeof require.ensure !== "function") {
    require.ensure = function (dependencies, callback) {
      return callback(require);
    };
  }
}

/**
 * A module providing tools to manage localization utilities in the frontend.
 */

/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

var FrontendLocaleManager = function (_LocaleManager) {
  (0, _inherits3.default)(FrontendLocaleManager, _LocaleManager);

  function FrontendLocaleManager() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$i18nextOptions = _ref.i18nextOptions;

    _ref$i18nextOptions = _ref$i18nextOptions === undefined ? {} : _ref$i18nextOptions;
    var _ref$i18nextOptions$u = _ref$i18nextOptions.useCache,
        useCache = _ref$i18nextOptions$u === undefined ? true : _ref$i18nextOptions$u,
        _ref$i18nextOptions$u2 = _ref$i18nextOptions.useLanguageDetector,
        useLanguageDetector = _ref$i18nextOptions$u2 === undefined ? true : _ref$i18nextOptions$u2,
        otherI18nextOptions = (0, _objectWithoutProperties3.default)(_ref$i18nextOptions, ["useCache", "useLanguageDetector"]),
        options = (0, _objectWithoutProperties3.default)(_ref, ["i18nextOptions"]);
    (0, _classCallCheck3.default)(this, FrontendLocaleManager);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FrontendLocaleManager.__proto__ || (0, _getPrototypeOf2.default)(FrontendLocaleManager)).call(this, (0, _extends3.default)({
      i18nextOptions: (0, _extends3.default)({
        useCache: useCache,
        useLanguageDetector: useLanguageDetector
      }, otherI18nextOptions)
    }, options)));

    _this.loadedLocales = new _set2.default();


    _this.initialize();
    return _this;
  }

  (0, _createClass3.default)(FrontendLocaleManager, [{
    key: "attachI18nextMiddleware",
    value: function attachI18nextMiddleware() {
      var _this2 = this;

      var _i18nextOptions = this.i18nextOptions,
          useCache = _i18nextOptions.useCache,
          useLanguageDetector = _i18nextOptions.useLanguageDetector;


      if (useCache) {
        this.i18next.use(_i18nextLocalstorageCache2.default);
      }

      if (useLanguageDetector) {
        this.i18next.use(_i18nextBrowserLanguagedetector2.default);
      }

      // Keep the locale synchronized upon detection.
      this.i18next.on("languageChanged", function (locale) {
        return _this2.changeLocale({ locale: locale });
      });
    }
  }, {
    key: "getI18nextConfiguration",
    value: function getI18nextConfiguration() {
      return (0, _frontend2.default)(this.i18nextConfiguration);
    }
  }, {
    key: "guessCurrentTimezone",
    value: function guessCurrentTimezone() {
      return _momentTimezone2.default.tz.guess();
    }
  }, {
    key: "initializeIntlPolyfill",
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function (_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!global.Intl && !global.IntlPolyfill)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", new _promise2.default(function (resolve) {
                  return require.ensure([], function (require) {
                    require("intl");
                    resolve();
                  });
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function initializeIntlPolyfill() {
        return _ref2.apply(this, arguments);
      };
    }()
  }, {
    key: "ensureLocaleIsLoaded",
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(_ref3) {
        var _this3 = this;

        var locale = _ref3.locale;
        var commonLocaleName;
        return _regenerator2.default.wrap(function (_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commonLocaleName = locale.toLowerCase();

                if (!this.loadedLocales.has(commonLocaleName)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                return _context2.abrupt("return", new _promise2.default(function (resolve) {
                  if (!global.IntlPolyfill) {
                    return resolve();
                  }

                  require.ensure([], function (require) {
                    require("intl/locale-data/jsonp/" + locale + ".js");
                    _this3.loadedLocales.add(commonLocaleName);
                    resolve();
                  });
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function ensureLocaleIsLoaded() {
        return _ref4.apply(this, arguments);
      };
    }()
  }]);
  return FrontendLocaleManager;
}(_LocaleManager3.default);

exports.default = FrontendLocaleManager;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@novivia/localization/lib/FrontendLocaleManager.js
// module id = 883
// module chunks = 6